module.exports = __webpack_public_path__ + "static/media/OGG.5cb65b3d.svg";